<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>新增商家</div>
    </div>

    <el-row class="filter">
      <div style="width: 80%; margin: 20px auto">
        <el-form
          ref="form"
          :model="form"
          :rules="rules"
          label-width="220px"
          class="demo-ruleForm"
        >
          <el-card
            class="box-card"
            :class="{
              'border-green': isAvailableStore === true,
              'border-red': isAvailableStore === false,
            }"
          >
            <el-form-item label="爆版手机账号">
              <el-input v-model="form.baobmobile">
                <template #append>
                  <el-button
                    style="padding: 0 8px"
                    type="text"
                    @click="getShopList"
                    >获取店铺列表</el-button
                  >
                </template>
              </el-input>
            </el-form-item>

            <el-form-item label="爆版店铺" prop="shopId">
              <el-select
                v-model="form.shopId"
                placeholder="请选择爆版店铺"
                @change="verifyShopInfo"
              >
                <el-option
                  v-for="item in shop_list"
                  :key="item.shopId"
                  :label="item.shopName"
                  :value="item.shopId"
                />
              </el-select>
            </el-form-item>

            <el-form-item label="是否自助上款" prop="is_self">
              <el-select
                v-model="form.is_self"
                placeholder="请选择是否自助上款"
              >
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>

            <el-form-item label="自助上款全类目" prop="is_all_style">
              <el-select
                v-model="form.is_all_style"
                placeholder="请选择自助上款全类目"
              >
                <el-option label="是" value="1" />
                <el-option label="否" value="0" />
              </el-select>
            </el-form-item>
          </el-card>
          <el-form-item label="商家名称">
            <el-input v-model="form.supply_name" :disabled="true" />
          </el-form-item>
          <el-form-item label="商家性质" prop="supply_character" required>
            <el-select
              v-model="form.supply_character"
              placeholder="请选择商家性质"
            >
              <el-option
                v-for="item in supply_character_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否可刷单" prop="is_scal">
            <el-select v-model="form.is_scal" placeholder="是否可刷单">
              <el-option
                v-for="item in is_scal_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="商家状态" prop="supply_status">
            <el-select
              v-model="form.supply_status"
              placeholder="商家状态"
              @change="changeStatus"
            >
              <el-option
                v-for="item in supply_status"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="合并账单日期" prop="bill_merger_date">
            <el-select
              v-model="form.bill_merger_date"
              style="width: 200px"
              multiple
              placeholder="合并账单日期"
            >
              <el-option
                v-for="item in Date_list"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <span class="select-option-tips">
              填写后，商家前置仓账单会根据每月已填写的日期进行自动合并。
            </span>
          </el-form-item>
          <el-form-item label="活动费扣取方式" prop="activity_fee_buckle">
            <el-radio v-model="form.activity_fee_buckle" label="1">
              账单方式
            </el-radio>
            <span class="activity-free-buckle-span"
              >选择此结算方式，商家活动费在账单中扣取。</span
            >
            <div>
              <el-switch
                v-if="form.activity_fee_buckle === '1'"
                v-model="form.open_qz_auto_buckle"
                active-value="1"
                inactive-value="2"
              >
              </el-switch>
              前置仓账单扣取
              <span class="open-qz-span">
                *若开启，则活动费抵扣可在前置仓代采订单中扣取，否则前置仓代采订单不自动扣取活动费。
              </span>
            </div>
          </el-form-item>
          <el-form-item prop="is_return_profit">
            <span slot="label">
              折扣让利（佣金）
              <el-tooltip effect="light">
                <div slot="content">
                  商家签订折扣让利协议后，按月销量达标的商品由商家让利给一手平台。
                </div>
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-radio-group v-model="form.is_return_profit">
              <el-radio label="1"> 参与 </el-radio>
              <el-radio label="2"> 不参与 </el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.is_return_profit === constantMap.isJoinProfit">
            <el-form-item
              label="让利账单生成周期 "
              prop="period_profit"
              :rules="commonRules.ruleChange"
            >
              <el-select
                v-model="form.period_profit"
                filterable
                placeholder="请选择"
              >
                <el-option
                  v-for="item in periodProfitStatus"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <span>
                如商家当前已经参与此协议，在切换账期模式后，本月仍保持旧的账期规则，直到下个月1号才会按新设置生效。若商家没参加过协议，或协议关闭已经超过一个月了，则马上生效。
              </span>
            </el-form-item>
            <el-form-item
              label="生效时间"
              prop="return_profit_month"
              :rules="commonRules.ruleChange"
            >
              <el-date-picker
                v-model="form.return_profit_month"
                :picker-options="constantMap.pickerOptions"
                type="date"
                size="small"
                value-format="yyyy-MM-dd"
                placeholder="选择生效时间"
              >
              </el-date-picker>
              <span style="color: gray">
                在生效日期起代采开单且发货出库的商品将进行让利销量统计，历史数据请在让利销量汇总表补生成
              </span>
            </el-form-item>
            <el-form-item
              label="结算方式"
              prop="clearing_form"
              :rules="commonRules.ruleChange"
            >
              <el-radio-group v-model="form.clearing_form">
                <el-radio label="1"> 代采单抵扣 </el-radio>
                <el-radio label="2"> 账单支付 </el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="商品要求"
              prop="reserve_price"
              :rules="commonRules.ruleBlur"
            >
              <YsInput
                v-model="form.reserve_price"
                pattern="money"
                style="min-width: 50%"
                size="small"
              >
                <span slot="prepend"> 非特价、且商家价&gt; </span>
                <span slot="append">元/件</span>
              </YsInput>
            </el-form-item>
            <el-form-item
              label="让利单价设置"
              prop="return_profit_rule"
              :rules="commonRules.ruleChangeArray"
            >
              <el-button
                type="primary"
                size="small"
                @click="handleReturnProfitRuleAdd"
              >
                添加设置行
              </el-button>
              <el-table :data="form.return_profit_rule" border size="mini">
                <el-table-column align="center" label="序号" width="80">
                  <template #default="{ $index }">
                    {{ $index + 1 }}
                  </template>
                </el-table-column>
                <el-table-column
                  prop="num"
                  align="center"
                  label="月度销售件数达标门槛（按商品货号）"
                >
                  <el-form-item
                    slot-scope="{ row, $index }"
                    :prop="`return_profit_rule.${$index}.num`"
                    :rules="commonRules.ruleBlur"
                  >
                    <YsInput
                      v-model="row.num"
                      pattern="positiveInt"
                      size="small"
                    >
                      <span slot="prepend">达到</span>
                      <span slot="append">件及以上时</span>
                    </YsInput>
                  </el-form-item>
                </el-table-column>
                <el-table-column prop="price" align="center" label="让利单价">
                  <el-form-item
                    slot-scope="{ row, $index }"
                    :prop="`return_profit_rule.${$index}.price`"
                    :rules="rulePrice"
                  >
                    <YsInput v-model="row.price" pattern="money" size="small">
                      <span slot="append">元/件</span>
                    </YsInput>
                  </el-form-item>
                </el-table-column>
                <el-table-column
                  prop="actions"
                  align="center"
                  label="操作"
                  width="100"
                >
                  <el-form-item slot-scope="{ $index }">
                    <el-button
                      v-if="form.return_profit_rule.length > 1"
                      type="danger"
                      size="small"
                      @click="handleReturnProfitRuleDel($index)"
                    >
                      删除
                    </el-button>
                  </el-form-item>
                </el-table-column>
              </el-table>
            </el-form-item>
          </template>
          <el-form-item label="城市" prop="city">
            <el-select
              v-model="form.city"
              filterable
              placeholder="城市"
              @change="handleSelectCity"
            >
              <el-option
                v-for="item in citys"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="市场（地理位置）" prop="father_market">
            <el-select
              v-model="form.father_market"
              filterable
              placeholder="市场"
              @change="setChild"
            >
              <el-option
                v-for="item in marketList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="子市场（地理位置）" prop="market_id">
            <el-select v-model="form.market_id" filterable placeholder="子市场">
              <el-option
                v-for="item in subMarketList"
                :key="item.key"
                :label="item.label"
                :value="item.key"
              />
            </el-select>
          </el-form-item>
          <el-form-item prop="attributable_market_id">
            <span slot="label">
              业绩归属市场
              <el-tooltip effect="light">
                <div slot="content">
                  用于统计公司内部各市场部门的业绩销售情况
                </div>
                <i class="el-icon-question" />
              </el-tooltip>
            </span>
            <el-select
              v-model="form.attributable_market_id"
              filterable
              placeholder="业绩归属市场"
              @change="
                handleSetAttributableSubMarket(form.attributable_market_id)
              "
            >
              <el-option
                v-for="item in performanceMarketList"
                :key="item.attributable_market_id"
                :label="item.attributable_market_name"
                :value="item.attributable_market_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="业绩归属细分市场"
            prop="attributable_market_sub_id"
          >
            <el-select
              v-model="form.attributable_market_sub_id"
              filterable
              placeholder="业绩归属细分市场"
            >
              <el-option
                v-for="item in performanceSubMarketList"
                :key="item.sub_id"
                :label="item.sub_name"
                :value="item.sub_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="楼层" prop="supply_floor">
            <el-select
              v-model="form.supply_floor"
              filterable
              placeholder="楼层"
              @change="genSupplyName"
            >
              <el-option
                v-for="item in resData.floor"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="区域/街" prop="supply_area_id">
            <el-select
              v-model="form.supply_area_id"
              filterable
              placeholder="区域/街"
              @change="genSupplyName"
            >
              <el-option
                v-for="item in resData.supply_area"
                :key="item.supply_area_id"
                :label="item.supply_area"
                :value="item.supply_area_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="档口号" prop="supplier_num">
            <el-autocomplete
              v-model="form.supplier_num"
              class="inline-input"
              :fetch-suggestions="querySearch"
              placeholder="请输入档口号"
              @select="handleSelect"
              @blur="genSupplyName"
            />
            <!--<el-input v-model="form.supply_name"></el-input>-->
          </el-form-item>
          <el-form-item label="一手商城档口名">
            <el-input
              v-model="form.supply_nickname"
              placeholder="显示于档口形象图上面的昵称（最多10个中文字）"
            />
          </el-form-item>
          <el-form-item label="品牌" prop="brand">
            <el-input
              v-model="form.brand"
              :disabled="true"
              style="width: 50%; float: left"
            />
            <el-button @click.prevent="brandVisible = true"> 编辑 </el-button>
          </el-form-item>

          <el-form-item label="代采组" prop="pgid">
            <el-select
              v-model="form.pgid"
              filterable
              placeholder="代采组"
              @change="getMemberOption"
            >
              <el-option
                v-for="item in resData.pg_list"
                :key="item.pgid"
                :label="item.pgname"
                :value="item.pgid"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="代采员" prop="pg_member_id">
            <el-select
              v-model="form.pg_member_id"
              filterable
              placeholder="代采员"
            >
              <el-option key="0" label="全部" value="0" />
              <el-option
                v-for="item in memberOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="次品组" prop="dgid">
            <el-select
              v-model="form.dgid"
              filterable
              placeholder="次品组"
              @change="getDefectiveGroupMember"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in defectiveGroupOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="次品员" prop="dg_member_id">
            <el-select
              v-model="form.dg_member_id"
              filterable
              placeholder="次品员"
              @change="handleChangeDgMemberId"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in defectiveGroupMemberOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="售后退供员" prop="refund_member_id">
            <el-select
              v-model="form.refund_member_id"
              filterable
              placeholder="售后退供员"
            >
              <el-option key="0" value="0" label="请选择" />
              <el-option
                v-for="item in refundMemberOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="买手组" prop="pg_id">
            <el-select
              v-model="form.pg_id"
              filterable
              placeholder="买手组"
              @change="getPickerGroupMemberOption"
            >
              <el-option
                v-for="item in resData.pickers"
                :key="item.pg_id"
                :label="item.pg_name"
                :value="item.pg_id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="买手" prop="supply_picker_group_member_id">
            <el-select
              v-model="form.supply_picker_group_member_id"
              filterable
              placeholder="买手"
            >
              <el-option key="0" value="0" label="无" />
              <el-option
                v-for="item in PickerGroupMemberOption"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="商家运营跟进人" prop="follower">
            <el-select
              v-model="form.follower_admin_id"
              filterable
              placeholder="商家运营跟进人"
            >
              <el-option
                v-for="item in resData.follower"
                :key="item.value"
                :disabled="item.admin_status == 0"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="商家开发人" prop="supply_developer">
            <el-select
              v-model="form.supply_developer_admin"
              filterable
              placeholder="商家开发人"
            >
              <el-option
                v-for="item in resData.supply_developer"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="前置仓跟进人" prop="pre_storage_admin">
            <el-select
              v-model="form.pre_storage_admin"
              filterable
              placeholder="前置仓跟进人"
            >
              <el-option
                v-for="item in resData.pre_storage_admin_list"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="联系方式">
            <el-input
              v-model="form.supply_mobile_phone"
              placeholder="手机"
              style="width: 45%; float: left"
            />
            <el-input
              v-model="form.supply_wechat"
              placeholder="微信"
              style="width: 45%; float: left"
            />
          </el-form-item>
          <el-form-item label="商品默认活跃值">
            <el-input
              v-model="form.supply_action_value"
              style="width: 45%"
              placeholder="商家新建商品默认活跃值"
            />
          </el-form-item>
          <el-form-item label="排单锁定天数" prop="limit_day">
            <el-input
              v-model="form.limit_day"
              type="number"
              style="width: 200px"
            >
              <template #append> 天 </template>
            </el-input>
          </el-form-item>
          <el-form-item label="超时断计划" prop="plan_time_out_days">
            <ys-input
              v-model="form.plan_time_out_days"
              pattern="positiveInt"
              min="1"
              max="999"
              style="width: 200px"
            >
              <template #append> 天 </template>
            </ys-input>
            <span>
              超过（大于）设定天数未开单且无客需的
              <span style="color: #f00">系统计划</span>
              及
              <span style="color: #f00">重采计划</span>
              （数量不足来源）以及
              <span style="color: #f00">虚拟库存采购计划</span>
              自动断待开单。
            </span>
          </el-form-item>

          <el-form-item
            v-for="(payee, index) in form.payees"
            :key="payee.key"
            :label="'收款人信息' + (index + 1)"
            :prop="'payees.' + index + '.value'"
          >
            <el-input
              v-model="payee.payee_name"
              placeholder="姓名"
              style="width: 20%; float: left"
            />
            <!--<el-input v-model="payee.payee_bank" placeholder="收款银行" style="width: 25%;float: left"> </el-input>-->
            <el-select
              v-model="payee.payee_bank"
              filterable
              placeholder="收款银行"
              style="width: 20%; float: left"
              @change="setBank"
            >
              <el-option
                v-for="item in resData.banks"
                :key="item"
                :label="item"
                :value="item"
              />
            </el-select>
            <el-select
              v-model="payee.cnap"
              filterable
              remote
              :remote-method="setCnap"
              placeholder="所屬支行(至少输入四位才可以筛选)"
              style="width: 20%; float: left"
            >
              <el-option value=""> 请选择 </el-option>
              <el-option
                v-for="item in cnaps"
                :key="item.cnap"
                :label="item.cnap_name"
                :value="item.cnap"
              />
            </el-select>
            <el-input
              v-model="payee.payee_bank_account"
              placeholder="账号"
              style="width: 20%; float: left"
            />
            <el-radio v-model="form.is_default" :label="index">
              默认收款账号
            </el-radio>
            <el-button @click.prevent="removePayee(payee)"> 删除 </el-button>
          </el-form-item>
          <el-button @click="addPayee"> 增加收款人 </el-button>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="form.remark" type="textarea" />
          </el-form-item>

          <el-form-item label="是否KA" prop="is_ka">
            <el-select v-model="form.is_ka" placeholder="是否KA">
              <el-option
                v-for="item in is_ka_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="是否实力档口" prop="is_strength">
            <el-select v-model="form.is_strength" placeholder="是否实力档口">
              <el-option
                v-for="item in is_strength_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="重新代采计划全量生成" prop="all_rebuild_plan">
            <el-select
              v-model="form.all_rebuild_plan"
              placeholder="重新代采计划全量生成"
            >
              <el-option
                v-for="item in is_strength_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启后，无论是否有客需，都会根据“重采操作”在次日等量生成“重新代采计划”。
            </span>
          </el-form-item>
          <el-form-item
            label="前置仓入库时消除待开单数据"
            prop="is_auto_cancel_plan"
          >
            <el-select
              v-model="form.is_auto_cancel_plan"
              placeholder="前置仓入库时消除待开单数据"
            >
              <el-option
                v-for="item in [
                  { label: '否', value: '1' },
                  { label: '是', value: '2' },
                ]"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              开启后，若前置仓入库时，采购计划中该sku待开单数将相应减少。
            </span>
          </el-form-item>
          <el-form-item label="退换货是否需接收" prop="reject_accept">
            <el-select
              v-model="form.reject_accept"
              placeholder="退换货是否需接收"
            >
              <el-option
                v-for="item in is_strength_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
            <span class="select-option-tips">
              是—>退换货出库后需要完成次品接收才会生成退换货欠货。否—>退换货出库后直接生成退换货欠货。
            </span>
          </el-form-item>

          <el-form-item label="是否全款全上" prop="is_strength">
            <el-select v-model="form.is_full" placeholder="是否全款全上">
              <el-option
                v-for="item in is_strength_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否自主上款" prop="is_self">
            <el-select v-model="form.is_self" placeholder="是否自主上款">
              <el-option
                v-for="item in is_strength_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="是否轻入驻" prop="is_lower_enter">
            <el-select v-model="form.is_lower_enter" placeholder="是否轻入驻">
              <el-option
                v-for="item in is_lower_enter_options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            v-if="form.is_lower_enter == 1"
            label="月目标"
            prop="m_goal"
          >
            <el-input v-model="form.m_goal" type="number" />
          </el-form-item>
          <el-form-item label="是否开启直播" prop="is_live">
            <el-select v-model="form.is_live" placeholder="是否开启直播">
              <el-option
                v-for="item in is_live"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item
            label="是否开启截图上款"
            prop="is_screenshot_for_add_goods"
            label-width="130px"
          >
            <el-select
              v-model="form.is_screenshot_for_add_goods"
              placeholder="是否开启截图上款"
            >
              <el-option
                v-for="item in is_screenshot_for_add_goods"
                :key="item.value"
                :value="item.value"
                :label="item.label"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="擅长季节" prop="season">
            <el-checkbox-group v-model="form.season" lable="擅长季节">
              <el-checkbox label="春季" />
              <el-checkbox label="夏季" />
              <el-checkbox label="秋季" />
              <el-checkbox label="冬季" />
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="适合年龄阶段" prop="season">
            <el-checkbox-group v-model="form.age_group">
              <el-checkbox
                v-for="age in resData.age_group"
                :key="age.key"
                :label="age.key"
              >
                {{ age.label }}
              </el-checkbox>
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="档次" prop="supply_grade">
            <el-checkbox-group v-model="form.supply_grade" lable="档次">
              <el-checkbox label="低端" />
              <el-checkbox label="中低" />
              <el-checkbox label="中端" />
              <el-checkbox label="中高" />
              <el-checkbox label="高端" />
            </el-checkbox-group>
          </el-form-item>

          <el-form-item label="擅长品类">
            <el-cascader
              v-model="form.cat_ids"
              placeholder="搜索品类"
              :options="resData.category"
              :props="{ multiple: true }"
              filterable
            />
          </el-form-item>

          <el-form-item label="主要风格">
            <el-transfer
              v-model="form.styles"
              filterable
              :titles="['选项', '选中']"
              filter-placeholder="请输入风格"
              :data="styles_data"
              @change="build_second_styles"
            />
          </el-form-item>
          <el-form-item label="副风格">
            <el-transfer
              v-model="form.second_styles"
              filterable
              :titles="['选项', '选中']"
              filter-placeholder="请输入风格"
              :data="second_styles_data"
              @change="build_styles"
            />
          </el-form-item>

          <el-form-item label="一手店铺底图">
            <el-col :span="24" :style="'width:100%;'">
              <el-upload
                :style="'width:100px;float:left;height:50px;'"
                class="upload-demo"
                :show-file-list="false"
                :action="action"
                style="display: inline-block; margin-right: 10px"
                multiple
                accept="image/*"
                :on-success="uploadSuccess1"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload"
                :on-exceed="handleExceed"
                :file-list="files"
                with-credentials
              >
                <el-button size="small" style="margin: 10px 3px" type="primary">
                  上传图片
                </el-button>
              </el-upload>
              <template>
                <div
                  v-for="(item, index) in images1"
                  v-if="images1"
                  :key="index"
                  style="
                    float: left;
                    width: 50px;
                    height: 50px;
                    margin: 0 10px;
                    border: 1px solid #ddd;
                  "
                >
                  <div style="position: relative">
                    <img
                      style="width: 50px; height: 50px"
                      :src="item"
                      @click="previewImage(item)"
                    />
                    <div
                      style="
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top: -5px;
                        right: -5px;
                      "
                      @click="deleteImg1(item)"
                    >
                      <img
                        style="width: 15px; height: 15px"
                        :src="origin + '/201804/13/15235857625ad012e238658.png'"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </el-col>
          </el-form-item>
          <el-form-item label="品牌logo">
            <el-col :span="24" :style="'width:100%;'">
              <el-upload
                :style="'width:100px;float:left;height:50px;'"
                class="upload-demo"
                :show-file-list="false"
                :action="action"
                style="display: inline-block; margin-right: 10px"
                multiple
                accept="image/*"
                :on-success="uploadSuccess3"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload3"
                :on-exceed="handleExceed3"
                :file-list="files"
                with-credentials
              >
                <el-button size="small" style="margin: 10px 3px" type="primary">
                  上传图片
                </el-button>
              </el-upload>
              <template>
                <div
                  v-for="(item, index) in images3"
                  v-if="images3"
                  :key="index"
                  style="
                    float: left;
                    width: 50px;
                    height: 50px;
                    margin: 0 10px;
                    border: 1px solid #ddd;
                  "
                >
                  <div style="position: relative">
                    <img
                      style="width: 50px; height: 50px"
                      :src="item"
                      @click="previewImage(item)"
                    />
                    <div
                      style="
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top: -5px;
                        right: -5px;
                      "
                      @click="deleteImg3(item)"
                    >
                      <img
                        style="width: 15px; height: 15px"
                        :src="origin + '/201804/13/15235857625ad012e238658.png'"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </el-col>
          </el-form-item>

          <el-form-item label="营业执照">
            <el-col :span="24" :style="'width:100%;'">
              <el-upload
                :style="'width:100px;float:left;height:50px;'"
                class="upload-demo"
                :show-file-list="false"
                :action="action"
                style="display: inline-block; margin-right: 10px"
                multiple
                accept="image/*"
                :on-success="uploadSuccess2"
                :on-remove="handleRemove"
                :before-upload="beforeAvatarUpload2"
                :on-exceed="handleExceed2"
                :file-list="files"
                with-credentials
              >
                <el-button size="small" style="margin: 10px 3px" type="primary">
                  上传图片
                </el-button>
              </el-upload>
              <template>
                <div
                  v-for="(item, index) in images2"
                  v-if="images2"
                  :key="index"
                  style="
                    float: left;
                    width: 50px;
                    height: 50px;
                    margin: 0 10px;
                    border: 1px solid #ddd;
                  "
                >
                  <div style="position: relative">
                    <img
                      style="width: 50px; height: 50px"
                      :src="item"
                      @click="previewImage(item)"
                    />
                    <div
                      style="
                        width: 15px;
                        height: 15px;
                        position: absolute;
                        top: -5px;
                        right: -5px;
                      "
                      @click="deleteImg2(item)"
                    >
                      <img
                        style="width: 15px; height: 15px"
                        :src="origin + '/201804/13/15235857625ad012e238658.png'"
                      />
                    </div>
                  </div>
                </div>
              </template>
            </el-col>
          </el-form-item>

          <el-form-item label="推荐描述">
            <el-input
              v-model="form.recommend_desc"
              style="width: 40%; float: left"
              maxlength="100"
            />
            <span style="color: red">
              一手APP上的商家推荐描述（建议30字以内，否则在手机上超出的部分可能会变为省略号）
            </span>
          </el-form-item>

          <el-form-item label="买手说">
            <el-input
              v-model="form.pg_say"
              placeholder="说点什么呢~"
              style="width: 40%; float: left"
            />
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="onSubmit"> 提交 </el-button>
          </el-form-item>
        </el-form>
        <el-row style="">
          <el-dialog :visible.sync="dialogVisible">
            <img width="100%" :src="dialogImageUrl" alt="" />
          </el-dialog>
        </el-row>

        <el-dialog
          title="品牌信息"
          :visible.sync="brandVisible"
          width="60%"
          center
        >
          <el-form :model="form">
            <el-form-item label="前端是否显示品牌名">
              <el-switch
                v-model="form.is_show_brand"
                inactive-color="#ff4949"
                active-color="#13ce66"
                inactive-value="0"
                active-value="1"
                inactive-text="不显示"
                active-text="显示"
              />
            </el-form-item>
            <el-form-item
              v-for="(brand, index) in form.brands"
              :key="brand.key"
              :label="'品牌' + (index + 1)"
              :prop="'brands.' + index + '.value'"
            >
              <el-input v-model="brand.key" style="display: none" />
              <el-input
                v-model="brand.brand_name"
                placeholder="品牌名"
                style="width: 70%; float: left"
              />
              <el-radio
                v-model="form.is_main"
                :label="index"
                :change="genSupplyName"
              >
                主品牌
              </el-radio>
              <el-button @click.prevent="removeBrand(brand)"> 删除 </el-button>
            </el-form-item>
            <!--<p style="color: orange">品牌1为主品牌</p>-->
            <el-button @click="addBrand"> 增加品牌 </el-button>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="brandVisible = false"> 取 消 </el-button>
            <el-button type="primary" @click="setBrand"> 确 定 </el-button>
          </div>
        </el-dialog>
      </div>
    </el-row>
    <el-row />
  </div>
</template>

<script>
import { pickBy } from "lodash-es";
import Global_ from "../../components/Global.vue";
import { CITY } from "@/const/CommonConst.js";
import rules from "@/const/rules.js";
import { completeMoneyDecimal } from "@/utils/tools/index.js";
import { validNonZeroMoney } from "@/utils/tools/validator.js";
import apiBaseURL from "@/utils/baseUrl.js";
import {
  getGetAttributableMarketList,
  postCheckShop,
} from "@/openapi/erp/supply.js";

const constantMap = {
  isJoinProfit: "1", // 参与折扣让利
  isNotJoinProfit: "2", // 不参与折扣让利
  deductByGoods: "1", // 待采单抵扣
  pickerOptions: {
    disabledDate: (date) => date.getTime() < Date.now(),
  },
};

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      isAvailableStore: null,
      commonRules: rules,
      constantMap,
      rulePrice: [
        rules.ruleBlur,
        { validator: validNonZeroMoney, trigger: "blur" },
      ],
      bank: "",
      cnaps: [],
      files: [],
      brandVisible: false,
      dialogVisible: false,
      dialogImageUrl: "",
      restaurants: [],
      timeout: null,
      floor_name: "",
      supply_area: "",
      brand_name: "",
      first_category: [],
      second_category: [],
      third_category: [],
      resData: {
        pg_list: [],
        reson_2: [],
      },
      supply: {
        list: [],
      },
      cats: [],
      pic: "",
      license: "",
      avatar: "",
      defectiveGroupMemberOption: [],
      defectiveGroupOption: [],
      refundMemberOption: [],
      Date_list: Array.from({ length: 31 }, (v, i) => i + 1), // 日期列表
      form: {
        baobmobile: "",
        father_market: "",
        market_id: "",
        city: "",
        is_show_brand: "1",
        is_main: 0,
        is_live: "",
        is_screenshot_for_add_goods: "",
        dgid: "0",
        dg_member_id: "0",
        refund_member_id: "0",
        brand: "",
        pg_member_id: "0",
        limit_day: 7,
        plan_time_out_days: "10",
        supplier_num: "",
        // brand1:'',
        status: "",
        create_time: [],
        supply_id: "",
        set_pgid: "", // 设置的代采组id
        is_scal: "0",
        activity_fee_buckle: "1", // 账单方式
        open_qz_auto_buckle: "1", // 前置仓账单扣取
        is_strength: "0",
        is_ka: "0",
        supply_status: "1",
        take_stock_on_plan: "1",
        bill_merger_date: [], // 合并订单信息
        supply_character: "0", // 商家性质 默认选中“常规合作商”
        payees: [
          {
            payee_name: "",
            payee_bank: "",
            payee_bank_account: "",
          },
        ],
        brands: [
          {
            key: 1,
            brand_name: "",
          },
        ],
        season: [],
        supply_grade: [],
        age_group: [{}],
        pic: "",
        license: "",
        avatar: "",
        styles: [],
        second_styles: [],
        category: [],
        cat: [],
        supply_developer_admin: "", // 商家开发人
        pre_storage_admin: "", // 前置仓跟进人
        supply_picker_group_member_id: "0",
        all_rebuild_plan: "0",
        reject_accept: "1",
        is_return_profit: constantMap.isNotJoinProfit, // 是否参与让利销售
        return_profit_month: "", // 生效日期
        clearing_form: constantMap.deductByGoods,
        reserve_price: "",
        return_profit_rule: [],
        period_profit: "", // 让利账单生成周期{1:月结,2:日结}
        is_auto_cancel_plan: "1", // 前置仓入库时消除待开单计划数据:{1:否;2:是}
        // 业绩归属市场
        attributable_market_id: "",
        // 业绩归属细分市场
        attributable_market_sub_id: "",
        is_all_style: "1", // 是否全款全上
        is_self: "1", // 是否自主上款
        shopId: "",
      },
      images1: [],
      images2: [],
      images3: [],
      styles_data: [],
      second_styles_data: [],
      advantage: "档口优点",
      disadvantage: "档口缺点",
      citys: CITY,
      supply_status: [
        {
          value: "0",
          label: "禁用",
        },
        {
          value: "1",
          label: "启用",
        },
      ],
      periodProfitStatus: [
        {
          value: "1",
          label: "按月生成",
        },
        {
          value: "2",
          label: "按天生成",
        },
      ],
      is_scal_options: [
        {
          value: "0",
          label: "是",
        },
        {
          value: "1",
          label: "否",
        },
      ],
      is_strength_options: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      is_ka_options: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      is_lower_enter_options: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      is_live: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],
      is_screenshot_for_add_goods: [
        {
          value: "0",
          label: "否",
        },
        {
          value: "1",
          label: "是",
        },
      ],

      // take_stock_on_plan_options: [
      //   {
      //     value: "0",
      //     label: "否",
      //   },
      //   {
      //     value: "1",
      //     label: "是",
      //   },
      // ],
      //  商家性质
      supply_character_options: [
        {
          label: "常规合作商",
          value: "0",
        },
        {
          label: "买手小店",
          value: "1",
        },
        {
          label: "小店渠道商",
          value: "2",
        },
      ],
      rules: {
        supplier_num: [
          {
            required: true,
            message: "请输入档口号",
            trigger: "blur",
          },
          {
            min: 1,
            max: 20,
            message: "档口号最长可以输入20个字符",
            trigger: "blur",
          },
        ],
        is_scal: [
          {
            required: true,
            message: "请选择是否可以刷单",
            trigger: "change",
          },
        ],
        activity_fee_buckle: [
          {
            required: true,
            message: "请选择是活动费扣取方式",
            trigger: "change",
          },
        ],
        supply_status: [
          {
            required: true,
            message: "请选择商家状态",
            trigger: "change",
          },
        ],
        bill_merger_date: [
          { required: true, message: "请选择合并账单日期", trigger: "change" },
        ],
        city: [{ required: true, message: "请选择城市", trigger: "change" }],
        father_market: [
          { required: true, message: "请选择市场", trigger: "change" },
        ],
        market_id: [
          {
            required: true,
            message: "请选择子市场",
            trigger: "change",
          },
        ],
        attributable_market_id: [
          {
            required: true,
            message: "请选择业绩归属市场",
            trigger: "change",
          },
        ],
        supply_floor: [
          { required: true, message: "请选择楼层", trigger: "change" },
        ],
        supply_area_id: [
          {
            required: true,
            message: "请选择区域/街",
            trigger: "change",
          },
        ],
        brand: [{ required: true, message: "请编辑品牌", trigger: "change" }],
        pgid: [
          {
            required: true,
            message: "请选择代采组",
            trigger: "change",
          },
        ],
        pg_member_id: [
          {
            required: true,
            message: "请选择代采员",
            trigger: "change",
          },
        ],
        dgid: [
          {
            required: true,
            message: "请选择次品组",
            trigger: "change",
          },
        ],
        dg_member_id: [
          {
            required: true,
            message: "请选择次品员",
            trigger: "change",
          },
        ],
        refund_member_id: [
          {
            required: true,
            message: "请选择售后退供员",
            trigger: "change",
          },
        ],
        limit_day: [
          {
            required: true,
            message: "请输入排单锁定天数",
            trigger: "blur",
          },
        ],
        plan_time_out_days: [rules.ruleBlur],
        is_return_profit: {
          required: true,
          message: "必选",
          trigger: "change",
        },
      },
      loading: false,
      tableLoading: false,
      url: "/erp/Supply/AddSupply",
      filterFold: false,
      supplyData: null,
      origin: Global_.origin,
      memberOption: [],
      marketList: [],
      subMarketList: [],
      PickerGroupMemberOption: [],
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
      performanceMarketList: [],
      shop_list: [],
    };
  },
  computed: {
    filteredForm() {
      return pickBy(
        this.form,
        (value) => ![undefined, null, ""].includes(value)
      );
    },
  },
  mounted() {
    this.fetchData();
    this.$http
      .get("/erp/Supply/getAllSupplierNum", this.filteredForm)
      .then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.restaurants = res.data.data;
        }
      });
    this.handleGetPerformanceMarketList();
  },
  methods: {
    async verifyShopInfo() {
      if (!this.form.shopId) {
        this.$message.error("请选择爆版店铺");
        this.isAvailableStore = false;
        return false;
      }
      return postCheckShop({ shopId: this.form.shopId })
        .then((res) => {
          this.isAvailableStore = true;
          // this.$message.success("验证成功");
          return true;
        })
        .catch(() => {
          this.isAvailableStore = false;
          return false;
        });
    },
    getMemberOption(e) {
      if (!e) {
        return;
      }
      this.memberOption = [];
      this.form.pg_member_id = "0";
      this.loading = true;
      this.$http.post("/erp/Common/getPgMember", { pgid: e }).then((res) => {
        this.loading = false;
        if (res.data.data.length < 1) {
          this.$message.info("请先绑定代采员至该代采组下");
          return;
        }
        this.memberOption = res.data.data;
      });
    },
    //  根据买手组id请求对应成员
    getPickerGroupMemberOption(e) {
      if (!e) {
        return;
      }
      this.PickerGroupMemberOption = [];
      this.form.supply_picker_group_member_id = "0";
      this.loading = true;
      this.$http
        .post("/erp/Common/getPickerGroupMember", { pg_id: e })
        .then((res) => {
          this.loading = false;
          if (res.data.data.length < 1) {
            this.$message.info("请先绑定买手到该买手组下");
            return;
          }
          this.PickerGroupMemberOption = res.data.data;
        });
    },
    addCat() {
      this.resData.category.forEach((cat) => {
        if (`${cat.key}` === `${this.form.cat3}`) {
          if (this.cats.indexOf(cat.label) >= 0) {
            return;
          }
          this.cats.push(cat.label);
          this.form.category.push(cat);
        }
      });
    },
    setCatChild(value) {
      this.second_category = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.resData.category) {
        if (`${value}` === `${this.resData.category[key].key}`) {
          this.resData.category.forEach((cat) => {
            if (`${cat.parent_id}` === `${value}`) {
              this.second_category.push(cat);
            }
          });
        }
      }
    },
    setCatChild1(value) {
      this.third_category = [];
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.resData.category) {
        if (`${value}` === `${this.resData.category[key].key}`) {
          this.resData.category.forEach((cat) => {
            if (`${cat.parent_id}` === `${value}`) {
              this.third_category.push(cat);
            }
          });
        }
      }
    },
    handleSelectCity(value) {
      // 重置数据
      this.form.father_market = "";
      this.form.market_id = "";
      this.form.is_show_brand = "1";
      this.marketList = [];
      this.subMarketList = [];
      this.$http
        .post("/erp/Supply/getMainMarket", { city: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.marketList = res.data.data;
          }
        });
    },
    setChild(value) {
      // 重置数据
      this.form.market_id = "";
      this.form.is_show_brand = "1";
      this.subMarketList = [];
      this.$http
        .post("/erp/Supply/getChildMarket", { parent_id: value })
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.subMarketList = res.data.data;
          }
        });
    },
    setBank(v) {
      this.bank = v;
    },
    setCnap(v) {
      if (v.length >= 4) {
        this.$http
          .post("/erp/common/getCnap", {
            bank: this.bank,
            cnap_name: v,
          })
          .then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.cnaps = res.data.data;
            }
          });
      }
    },
    handleClose(tag) {
      this.cats.splice(this.cats.indexOf(tag), 1);
      this.form.category.splice(this.form.category.indexOf(tag), 1);
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.get(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          res.data.data.category.forEach((cat) => {
            if (`${cat.parent_id}` === "0") {
              this.first_category.push(cat);
            }
          });
          this.resData = res.data.data;
          this.build_styles();
          this.build_second_styles();
          this.handleCityChange();
        }
      });
    },
    handleSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          const params = {
            ...this.filteredForm,
            reserve_price: completeMoneyDecimal(
              this.filteredForm.reserve_price
            ),
            return_profit_rule: this.filteredForm.return_profit_rule.map(
              (item) => ({ ...item, price: completeMoneyDecimal(item.price) })
            ),
            // 商家列表折扣让利设置  后端必传  默认属性
            return_profit_goods_type: "1",
            return_profit_goods_file: "",
          };
          this.loading = true;
          this.$http.post(this.url, params).then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 200);
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message({
                type: res.data.data.msg_type,
                message: res.data.data.msg,
              });
              this.form = {
                brands: [
                  {
                    key: 1,
                    brand_name: "",
                  },
                ],
                payees: [
                  {
                    payee_name: "",
                    payee_bank: "",
                    payee_bank_account: "",
                  },
                ],
              };
              this.$router.push("/home/supply/supplylist");
            }
          });
        } else {
          this.$message.info("请完善必填信息");
        }
      });
    },
    async onSubmit() {
      const isVerfied = await this.verifyShopInfo();
      if (!isVerfied) {
        this.$confirm(
          "爆版店铺信息有异常，建议再次验证店铺信息，否则提交后只会创建商家ID，不会进行爆版店铺绑定。",
          "提示",
          {
            confirmButtonText: "只创建商家 ID",
            cancelButtonText: "取消",
            type: "warning",
          }
        ).then(() => {
          this.form.shopId = "";
          this.form.baobmobile = "";
          this.handleSubmit();
        });
      } else {
        this.handleSubmit();
      }
    },
    removePayee(item) {
      const index = this.form.payees.indexOf(item);
      if (index !== -1) {
        this.form.payees.splice(index, 1);
      }
    },
    addPayee() {
      this.form.payees.push({
        key: Date.now(),
        payee_name: "",
        payee_bank: "",
        payee_bank_account: "",
      });
    },
    removeBrand(item) {
      const index = this.form.brands.indexOf(item);
      if (index !== 0) {
        this.form.brands.splice(index, 1);
      }
    },
    addBrand() {
      this.form.brands.push({
        key: Date.now(),
        brand_name: "",
      });
    },
    setBrand() {
      this.form.brand = "";
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.form.brands) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key2 in this.form.brands) {
          if (key !== key2) {
            if (
              this.form.brands[key].brand_name ===
              this.form.brands[key2].brand_name
            ) {
              this.$message.error("品牌名不能重复", "提示");
              return;
            }
          }
        }
        if (this.form.brands[key].brand_name) {
          this.form.brand += `${this.form.brands[key].brand_name},`;
        }
      }
      this.genSupplyName();
      this.brandVisible = false;
    },
    // 查询
    querySearch(queryString, cb) {
      const { restaurants } = this;
      const results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        );
      };
    },
    changeStatus(value) {
      if (`${value}` === "0") {
        this.$confirm("禁用后，该商家的所有商品将变为“断货”状态", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          showClose: false,
          type: "warning",
        })
          .then(() => {})
          .catch(() => {
            this.form.supply_status = "1";
          });
      }
    },
    genSupplyName() {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.resData.floor) {
        if (
          `${this.form.supply_floor}` === `${this.resData.floor[key].value}`
        ) {
          this.floor_name = this.resData.floor[key].label;
        }
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const key in this.resData.supply_area) {
        if (
          `${this.form.supply_area_id}` ===
          `${this.resData.supply_area[key].supply_area_id}`
        ) {
          this.supply_area = this.resData.supply_area[key].supply_area;
        }
      }
      this.brand_name = this.form.brands[this.form.is_main].brand_name;
      if (`${this.form.supply_area_id}` === "0") {
        this.form.supply_name = `${this.floor_name}-${this.form.supplier_num}-${this.brand_name}`;
      } else {
        this.form.supply_name = `${this.floor_name}-${this.supply_area}-${this.form.supplier_num}-${this.brand_name}`;
      }
    },
    // 图片
    getSizeArr(val) {
      // eslint-disable-next-line no-restricted-syntax
      for (const key in val.all_item) {
        if (val.co_val === key) {
          this.$set(val, "sizeval_ary", val.all_item[key]);
        }
      }
      // 清空已经上次选择的尺码
      this.$set(val, "si_val", "");
    },
    beforeAvatarUpload(file) {
      if (this.pic !== "") {
        this.$message.warning("只能上传一张");
        return;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
      }
    },
    beforeAvatarUpload2(file) {
      if (this.license !== "") {
        this.$message.warning("只能上传一张");
        return;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
      }
    },
    beforeAvatarUpload3(file) {
      if (this.avatar !== "") {
        this.$message.warning("只能上传一张");
        return;
      }
      const size = (file.size / 1024 / 1024).toFixed(2);
      if (size > 2) {
        this.$message.error(
          `图片太大了,请缩小到2MB以内再上传,当前图片大小:${size}MB`
        );
      }
    },
    previewImage(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },
    deleteImg1(v) {
      if (this.images1.indexOf(v) >= 0) {
        this.images1.splice(this.images1.indexOf(v), 1);
        this.form.pic = "";
        this.pic = "";
      }
    },

    deleteImg2(v) {
      if (this.images2.indexOf(v) >= 0) {
        this.images2.splice(this.images2.indexOf(v), 1);
        this.form.license = "";
        this.license = "";
      }
    },
    uploadSuccess1(res) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        this.form.pic = res.data.files[0];
        this.pic = res.data.files[0];
        if (this.images1.indexOf(img) < 0) {
          this.images1.push(img);
        }
      }
    },
    uploadSuccess2(res) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;
        this.form.license = res.data.files[0];
        if (this.images2.indexOf(img) < 0) {
          this.images2.push(img);
        }
      }
    },
    uploadSuccess3(res) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        const img = `${this.origin}/${res.data.files[0]}`;

        const image = new Image();
        image.src = img;
        const z = this;
        image.onload = function () {
          const { width, height } = image;
          if (width !== height) {
            z.$message.error("必须上传正方形");
          } else if (
            width > 800 ||
            width < 130 ||
            height > 800 ||
            height < 130
          ) {
            z.$message.error("长宽必须在130px~800px之间");
          } else {
            z.form.avatar = res.data.files[0];
            if (z.images3.indexOf(img) < 0) {
              z.images3.push(img);
            }
          }
        };
      }
    },
    handleRemove() {},
    handleExceed() {
      if (this.pic !== "") {
        this.$message.warning("只能上传一张");
      }
    },

    handleExceed2() {
      if (this.license !== "") {
        this.$message.warning("只能上传一张");
      }
    },

    handleExceed3() {
      if (this.avatar !== "") {
        this.$message.warning("只能上传一张");
      }
    },
    build_second_styles() {
      this.second_styles_data = [];
      const { style } = this.resData;
      if (this.form.styles) {
        for (let i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is = this.form.styles.some((v) => {
            return style[i].key === v;
          });
          if (is) {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.second_styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
      }
    },
    build_styles() {
      this.styles_data = [];
      const { style } = this.resData;
      if (this.form.second_styles) {
        for (let i = 0, len = style.length; i < len; i++) {
          // 判断in_array
          const is = this.form.second_styles.some((v) => {
            return style[i].key === v;
          });
          if (is) {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
              disabled: true,
            });
          } else {
            this.styles_data.push({
              key: this.resData.style[i].key,
              label: this.resData.style[i].label,
            });
          }
        }
      }
    },
    handleCityChange() {
      this.$http
        .post("/erp/Defective/getCityGroups", {
          city: -1,
        })
        .then((res) => {
          if (`${res.data.code}` === "200") {
            this.form.dgid = "0";
            this.form.dg_member_id = "0";
            this.defectiveGroupOption = res.data.data.group;
            this.defectiveGroupMemberOption = [];
            this.refundMemberOption = [];
          }
        });
    },
    getDefectiveGroupMember(val) {
      if (!val) {
        return;
      }
      this.form.dg_member_id = "0";
      this.form.refund_member_id = "0";
      this.defectiveGroupMemberOption = [];
      this.refundMemberOption = [];
      this.$http
        .post("/erp/Defective/getGroupMember", {
          dgid: val,
        })
        .then((res) => {
          if (`${res.data.code}` === "200") {
            this.defectiveGroupMemberOption = res.data.data.member;
            this.refundMemberOption = res.data.data.refundMember;
          }
        });
    },
    // 选择次品员
    handleChangeDgMemberId(val) {
      // 如果未选择售后退供员同时次品员也是售后退供员，则售后退供员设置为当前次品员
      if (this.form.refund_member_id === "0") {
        const { dg_member_id: dgMemberId } = this.form;
        const refundMemberOptionValues = this.refundMemberOption.map(
          (item) => item.value
        );
        if (refundMemberOptionValues.includes(dgMemberId)) {
          this.form.refund_member_id = val;
        }
      }
    },
    handleReturnProfitRuleAdd() {
      this.form.return_profit_rule.push({ num: "", price: "" });
    },
    handleReturnProfitRuleDel(index) {
      this.form.return_profit_rule.splice(index, 1);
    },
    handleGetPerformanceMarketList() {
      getGetAttributableMarketList()
        .then((res) => {
          this.performanceMarketList = res;
        })
        .catch(this.$noop);
    },
    getShopList() {
      this.loading = true;
      this.$http
        .post("/erp/supply/getBaobShopList", {
          baobmobile: this.form.baobmobile.trim(),
          supply_id: "0", // 新建商家，没有supply_id
        })
        .then((res) => {
          this.loading = false;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success("获取成功");
            this.shop_list = res.data.data.shop_list;
          }
        });
    },
    handleSetAttributableSubMarket(attributableMarketId) {
      this.form.attributable_market_sub_id = "";
      const selectedMainMarket = this.performanceMarketList.find(
        (option) => option.attributable_market_id === attributableMarketId
      );
      if (selectedMainMarket) {
        this.performanceSubMarketList = selectedMainMarket.sub_list;
      } else {
        this.performanceSubMarketList = [];
      }
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.select-option-tips {
  color: #606266;
  margin-left: 10px;
}

.open-qz-span {
  color: red;
  display: inline-block;
  margin-left: 68px;
}

.activity-free-buckle-span {
  color: #444;
  display: inline-block;
  margin-left: 100px;
}

.form-section {
  border: 8px solid #ccc;
  padding: 10px;
  margin-bottom: 20px;
}

.box-card {
  /* border: 1px solid #ddd; */
  padding: 10px;
  margin-bottom: 38px;
}

.action-button {
  margin-top: 20px;
  float: right;
  margin-bottom: 20px;
}

.border-red {
  border: 2px solid red;
}

.border-green {
  border: 2px solid green;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/AddSupply.vue